import { createApp } from 'vue';
import App from '@learner/App.vue';

import { createPinia } from 'pinia';
import router from '@learner/router';
import $api from '@shared/src/lib/ApiWrapper';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { initFeatureFlagsBeforeMount, onFeatureFlagDegraded } from '@shared/src/lib/feature-flags';
import '@learner/scss/entry.scss';

const pinia = createPinia();
const app = createApp(App);
app.config.globalProperties.$api = $api;

app.use(pinia);
app.use(router);
app.use(VueDOMPurifyHTML);

// A degraded provider serves every flag its call-site default, which looks identical to every flag
// being switched off — surface it until real error reporting lands (R9 / TL-3955).
onFeatureFlagDegraded(({ requested, resolved, reason }) => {
  console.error(`Feature flags degraded from "${requested}" to "${resolved}": ${reason}`);
});

// Lets flagged UI render against real values, capped so a slow provider cannot hold up boot.
// The catch guards the top-level await: an unhandled rejection would mean a blank page (R6).
await initFeatureFlagsBeforeMount().catch((error) => {
  console.error('Feature flag initialisation failed; every flag will serve its default.', error);
});

app.mount('#app-wrap');
